import API from './index';

export const servicesAPI = {
  getAll: () => API.get('/services'),
  getAdminAll: () => API.get('/services/all'),
  getById: (id) => API.get(`/services/${id}`),
  create: (service) => API.post('/services', service),
  update: (id, service) => API.put(`/services/${id}`, service),
  delete: (id) => API.delete(`/services/${id}`)
};